const getQueryIdFromUrl = () => {
	const url = new URL(window?.location?.href);
	const queryID = url?.searchParams?.get('queryID');
	return queryID;
};

export default getQueryIdFromUrl;
